<script>
import mixinComponent from '../../../Mixins/mixinComponent'

export default {
  mixins: [mixinComponent],

  props: {
    isCollapsed: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
<template>
  <div ref="filterAccordion" class="accordion" :class="{ expanded: !isCollapsed }">
    <div>
      <slot></slot>
    </div>
  </div>
</template>
